<template>
  <v-app class="login">
    <v-container fill-height fluid>
      <v-row align="center" justify="center">
        <ValidationObserver ref="validator">
          <v-card width="340px" class="form" align="center" elevation="20">
            <v-toolbar color="primary" flat>
              <v-toolbar-title class="title" style="width: 100%">
                <h3>Ayuda</h3>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text v-if="status !== 'done'">
              <v-form ref="form" v-model="valid" class="mt-8">
                <ValidationProvider ref="spot_id" rules="required" v-slot="{ errors }">
                  <v-select :error-messages="errors" v-model="data.spot_id" :items="spots" item-text="address"
                    item-value="id" label="Lugar"></v-select>
                </ValidationProvider>
                <ValidationProvider ref="help_option_id" rules="required" v-slot="{ errors }">
                  <v-select :error-messages="errors" v-model="data.help_option_id" :items="help_options"
                    item-text="title" item-value="id" label="Opciones de Ayuda"></v-select>
                </ValidationProvider>
                <ValidationProvider ref="comment" rules="required">
                  <v-textarea slot-scope="{ errors }" :error-messages="errors" v-model="data.comment" type="text"
                    name="comment" label="Comentario" autocomplete="off" rows="8"></v-textarea>
                </ValidationProvider>
                <ValidationProvider ref="picture" rules="" v-slot="{ errors }">
                  <Upload :error-messages="errors" accept="image/png, image/jpeg, image/jpg" placeholder="Imagen"
                    prepend-icon="fas fa-camera" label="" :multiple="false" :onSelectedPicture="onSelectedPicture">
                  </Upload>
                  <v-img :src="picture" width="200" style="margin: auto"></v-img>
                </ValidationProvider>
              </v-form>
            </v-card-text>
            <v-card-actions v-if="status !== 'done'">
              <v-btn class="submit mt-2" block rounded elevation="0" color="info" @click="send"
                :loading="status === 'loading'">
                enviar
              </v-btn>
            </v-card-actions>
            <v-alert v-if="validation_message !== ''" type="error">
              {{ validation_message }}
            </v-alert>
            <v-card-text v-if="status === 'done'">
              <p class="font-italic">Gracias por usar nuestro servicio</p>
            </v-card-text>
          </v-card>
        </ValidationObserver>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import { mapActions, mapState } from "vuex";
import swal from "sweetalert";
import Upload from "@/components/Upload/index.vue";
extend("email", email);
extend("required", {
  ...required,
  message: "Este campo es requerido"
});
export default {
  computed: {
    ...mapState({
      spots: state => state.Spots.list,
      help_options: state => state.Help_options.list
    })
  },
  created() {
    this.getAllSpots();
    this.getAllHelpOptions();
  },
  watch: {
    //
  },
  data: () => ({
    validation_message: "",
    status: "",
    valid: false,
    picture: "",
    data: {
      spot_id: "",
      help_option_id: "",
      comment: "",
      picture: ""
    }
  }),
  methods: {
    ...mapActions({
      getAllSpots: "Spots/getListAll",
      getAllHelpOptions: "Help_options/getListAll"
    }),
    onSelectedPicture(file) {
      const self = this;
      this.data.picture = file;

      let fr = new FileReader();
      fr.onload = function () {
        self.picture = fr.result;
      };
      fr.onerror = function () {
        self.picture = "";
      };
      fr.readAsDataURL(this.data.picture);
    },
    async send() {
      const self = this;
      const valid = await this.$refs.validator.validate();
      self.setValidationMessage("");
      if (valid) await this.sendHelp();
    },
    setValidationMessage(message) {
      this.validation_message = message;
    },
    async sendHelp() {
      this.status = "loading";
      const self = this;
      self.$store
        .dispatch("Spot_helps/create", this.data)
        .then(() => {
          swal("Datos enviados correctamente", "");
          self.status = "done";
        })
        .catch(error => {
          self.setValidationMessage("Datos Inválidos");
          self.status = "";
        });
    }
  },
  components: {
    Upload,
    ValidationProvider,
    ValidationObserver
  }
};
</script>
